module.exports = __webpack_public_path__ + "static/media/LogoStraitTimes.2b37dfc6.png";